import { gql } from 'graphql-request'

export const GET_USER_PEN_NAMES = gql`
  query GetUserPenNames($userId: Int!) {
    getUserPenNames(userId: $userId) {
      id
      firstPenName
      secondPenName
      facebookLink
      twitterLink
      totalBook
    }
  }
`

export const GET_USER_PROFILE_PEN_NAMES = gql`
  query GetUserProfilePenNames($userId: Int!) {
    getUserProfilePenNames(userId: $userId, orderBy: { createdAt: DESC }) {
      id
      firstPenName
      secondPenName
      facebookLink
      twitterLink
      totalBook
    }
  }
`

export const GET_PEN_NAME_BY_PEN_NAME = gql`
  query GetByPenName($getByPenNameInput: GetByPenNameInput!) {
    getByPenName(getByPenNameInput: $getByPenNameInput) {
      id
      firstPenName
      user {
        id
      }
    }
  }
`
